// Clears any query parameters from the current url.
export default async () => window !== `undefined` && window.history.replaceState({}, document.title, '/');
